import React, { useEffect } from "react";
import { useSubscription, gql } from "@apollo/client";
import FloatingCta from "../floating-cta/index.component";
import useRouteHook from "../../hooks/useRoute.hook";
import { qsrOrderStatus } from "common/helpers/order.helper";

import OrderTracker from "@urbanpiper-engineering/meraki-components/dist/Cells/OrderTracker";

import "./index.component.scss";

export default function FloatingOrder(props) {
  const { config, order } = props;
  const { historyPush } = useRouteHook();
  const [orderStatus, setOrderStatus] = React.useState(order.order_state);
  useEffect(() => setOrderStatus(order.order_state), [order.order_state]);

  const { data } = useSubscription(
    gql`
      subscription getOrderUpdate($orderId: Int!) {
        getOrderUpdates(order_id: $orderId) {
          new_state
        }
      }
    `,
    { variables: { orderId: +order.id } },
  );

  useEffect(() => {
    if (data && data.getOrderUpdates) {
      setOrderStatus(data.getOrderUpdates.new_state);
    }
  }, [data]);

  return (
    <FloatingCta
      config={config}
      onClickCallback={() => {
        historyPush(`/order-success/${order?.id}`);
      }}
      noColor={true}
    >
      <div className="order-tracker-overview">
        <OrderTracker
          orderId={order?.id}
          orderStatus={qsrOrderStatus(orderStatus)}
        />
      </div>
    </FloatingCta>
  );
}
